module.exports = __webpack_public_path__ + "img/s5.6ee0cb51.jpg";